import { defineStore } from 'pinia'
import { AppStoreEnum } from '#lib/enums'

export interface ModalsStore {
  /**
   * Indicates whether the authentication is open or not.
   */
  isOpenAuthentication: boolean

  /**
   * Indicates whether the expired modal is open or not.
   */
  isOpenExpiredModal: boolean
}

export const useModalsStore = defineStore(AppStoreEnum.Modals, {
  state: (): ModalsStore => ({
    isOpenAuthentication: false,
    isOpenExpiredModal: false,
  }),
  persist: false,
  actions: {
    setOpenAuthModal(value: boolean) {
      this.isOpenAuthentication = value
    },
    setOpenExpireModal(value: boolean) {
      this.isOpenExpiredModal = value
    },
    reset() {
      this.isOpenAuthentication = false
      this.isOpenExpiredModal = false
    },
  },
})
